import { usePropertyAcquisitionDate } from '../../../queries/PropertyFields/NonRentalCoreFields';
import { DateTimeBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../components/ApplicationQuestionReviewItem';
import { formatDate } from '../../../../../../admin/src/common/SharedFunctions';
import { DateTimeBoxLabelSize } from '@apply/components/src/components/controls/DateBox/DateTimeBox';

export interface DateOfAcquisitionProps {
    propertyGuid: string;
    readOnly?: boolean;
    required?: boolean;
    isReview?: boolean;
    labelSize?: DateTimeBoxLabelSize;
}

export const DateOfAcquisition: React.FC<DateOfAcquisitionProps> = ({
    propertyGuid,
    readOnly = false,
    required = false,
    isReview = false,
    labelSize = DateTimeBoxLabelSize.Small,
}) => {
    const label = 'Date of acquisition (actual or expected)';
    const [acquisitionDate, set_acquisitionDate] = usePropertyAcquisitionDate(propertyGuid);

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatDate(acquisitionDate)}
                />
            ) : (
                <DateTimeBox
                    required={required}
                    value={acquisitionDate}
                    onChange={(value) => set_acquisitionDate(value)}
                    label={label}
                    labelSize={labelSize}
                    readOnly={readOnly}
                    width='220px'
                />
            )}
        </>
    );
};
